import {useCallback} from "react";
import type EditablePropertyItems from "../../../../types/EditablePropertyItems";
import useConstructionNewHook from "../../../../hooks/useConstructionNewHook";

const useEditableHook = (): {
  getConstructionPropertyItemsFromMatRef: (constructionElementsName: string, property: string, filter: string) => Promise<EditablePropertyItems | null>;
} => {
  const {getValuesFromMatRef} = useConstructionNewHook();

  const getConstructionPropertyItemsFromMatRef = useCallback(async (
    constructionElementsName: string,
    property: string,
    filter: string,
  ): Promise<EditablePropertyItems | null> => {
    const response = await getValuesFromMatRef(constructionElementsName, property, filter);
    return response?.data ?? null;
  }, [getValuesFromMatRef]);

  return {
    getConstructionPropertyItemsFromMatRef,
  };
};

export default useEditableHook;
